<template>
  <div class="userSelection common_group">
    <div class="title">
      <img src="@/assets/images/userIcon.png">
      <span>
        <span v-if="mustWrite" style="color:#f00">*</span>
        {{ $t('industryReport.zdnyqkf') }}
      </span>
      <div class="buttonBar">
        <el-upload
          ref="importTraderUpload"
          style="float: right;"
          :action="baseUrl"
          :headers="uploadheaders"
          :with-credentials="true"
          multiple
          :file-list="fileList"
          :show-file-list="false"
          :before-upload="beforeUpload"
          :on-success="uploadSuccess"
          :on-error="handleError"
        >
          <el-button plain :disabled="btnDisabled">{{ $t('newApp.Customers.ei') }}</el-button>
        </el-upload>
        <el-button type="text" @click="templateDownload" :disabled="btnDisabled">
          {{ $t('newApp.Customers.dt')
          }}
        </el-button>
        <el-button plain @click="addUserBtn" :disabled="btnDisabled">{{ $t('newApp.Customers.ac') }}</el-button>
      </div>
    </div>
    <!-- <el-button @click="loadStatisticsTable">a</el-button>
    <el-button @click="addtatisticsTable">b</el-button> -->
    <commonTable v-show="tableData.length > 0" ref="statisticsTable" style="margin-bottom:20px" />
    <commonTable ref="userSelectionTable" />
    <addUserDialog :edit-data="rowData" :add-user-dialog-visible="addUserDialogVisible"
                   @addUserListHandlen="addUserListHandlen" @editUserListHandlen="editUserListHandlen"
                   @dialogCloseHandle="addUserDialogClose" :edit-echo-data="editEchoData"
    />
    <customerDialog ref="customerDialog" :export-customer-visible="exportCustomerVisible" :calibration="calibration" @dialogCloseHandle="exportCustomerDialogCloseHandle" @dialogSuccessHandle="dialogSuccessHandle"/>
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import addUserDialog from './../userSelection/industryAddUserDialog.vue';
import { travellingTrader } from '../../../activitieList/service/index.js';
import requestBaseUrl from '@/API/request/baseUrl';
import { getTicket } from '@/utils/utils';
import { newApplicationFormApi } from '../../service';
import customerDialog from '@/components/customerDialog';
import { confirmBusiness } from '@/utils/exportComplianceDialog';

export default {
  name: 'UserSelection',
  data () {
    return {
      tableData: [],
      addUserDialogVisible: false,
      rowData: {},
      baseUrl: `${requestBaseUrl}/customer/calibration/excel/1/`,
      uploadheaders: {
        sysId: window._env_.VUE_APP_SYSID,
        union_session_ticket: getTicket()
      },
      fileList: [],
      btnDisabled: false,
      statisticsTable: [],
      businessList: [],
      exportCustomerVisible: false,
      calibration: {}
    };
  },
  components: {
    commonTable,
    addUserDialog,
    customerDialog
  },
  props: {
    editEchoData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    cacheList: {
      type: Object,
      default: () => {
        return {};
      }
    },
    mustWrite: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getTableData () {
      return this.$refs.userSelectionTable.staticTableList;
    },
    addUserBtn () {
      this.addUserDialogVisible = true;
    },
    // 文件上传成功回调
    uploadSuccess (res, file) {
      this.baseUrl = this.baseUrl.split('/RJM')[0] + '/';
      this.$store.commit('setSubPageLoading', false);
      confirmBusiness(this, res, { notifyError: true }).then(passed => {
        if (passed) {
          if (res.data.hasCalibration) {
            this.calibration = res.data.calibration;
            this.exportCustomerVisible = true;
          } else {
            this.$message.success(this.$t('general.ImpSucc'));
            this.dialogSuccessHandle(res);
          }
        }
      });
    },
    handleError () {
      this.$store.commit('setSubPageLoading', false);
      this.$message.error(this.$t('file.Fuf'));
    },
    // 导出客户弹窗确认按钮回调
    dialogSuccessHandle (res) {
      this.exportCustomerVisible = false;
      this.fileList = [];
      if (res.status === '200') {
        const directPassCustomers = JSON.parse(JSON.stringify(res.data.directPassCustomers || []));
        let returnVal = directPassCustomers.map(item => {
          let columnName = item.columnName;

          if (!columnName) {
            columnName = item.isChannel === this.$t('general.Channel') ? this.$t('general.msch') : this.$t('general.mscu');
          }
          return {
            clientName: item.clientName,
            isChannel: item.isChannel,
            matchResult: item.matchResult,
            businessChance: item.businessChance,
            businessChanceCode: item.businessChanceCode,
            output: item.output,
            columnName: columnName,
            isOldAccount: item.isOldAccount,
            name: item.name,
            telephone: item.phone,
            entityType: item.entityType,
            channelContractType: item.channelContractType,
            circleName: item.circleName,
            coconstructionOrNot: item.coconstructionOrNot,
            recordType: 'invite',
            accountMarked: item.accountMarked,
            // 上传文件后新增是否可能产生新建业务机会选项回显
            newBusOpp: item.newBusOpp,
            businessChanceList: item.businessChanceList ? item.businessChanceList : item.businessChance?.split(',') || [],
            mustFollowC: item.mustFollowCustomer
          };
        });
        this.addUserListHandlen(returnVal);
      } else {
        this.$message.error(res.err);
      }
    },
    // 导出客户弹窗关闭
    exportCustomerDialogCloseHandle () {
      this.exportCustomerVisible = false;
    },
    fileImport () {
      // let formData = new FormData();
    },
    beforeUpload (file) {
        let fileSize = file.size / 1024 / 1024 < 10;
        if (!fileSize) {
          this.$message.error(this.$t('newApp.Customers.ufsce1'));
          return false;
        }
        this.$store.commit('setSubPageLoading', true);
        return new Promise((resolve) => {
        if (this.$route.query.activityCode) {
          this.baseUrl = this.baseUrl + this.$route.query.activityCode;
        } else {
          this.baseUrl = this.baseUrl + this.$store.state.newApplication.activityCode;
        }
        resolve();
      });
    },
    repeatVerification (data) {
      let isRepeat;

      // 客户名称
      let companyName = [];

      // 客户联系人
      let contactName = [];

      data.forEach(item => {
        companyName.push(item.clientName);
      });
      // 因为是假分页，假分页staticTableList是全部数据，tableData.dataList是显示数据
      isRepeat = this.$refs.userSelectionTable.staticTableList.some(item => {
        if (companyName.indexOf(item.clientName) !== -1) {
          return true;
        }
        return false;
      });
      return isRepeat;
    },
    editUserListHandlen (data) {
      // 如果客户名称或者客户联系人发生改变，则进行重复校验
      if (this.rowData.clientName !== data[0].clientName || this.rowData.name !== data[0].name) {
        let isRepeat = this.repeatVerification(data);
        if (isRepeat) {
          this.$message.error(this.$t('newApp.Customers.ahtci'));
          return;
        }
      }

      this.$refs.userSelectionTable.staticReviseRow(data[0]);

      // 编辑后同步列表数据并刷新统计表
      this.tableData = [...this.$refs.userSelectionTable.staticTableList];
      this.$set(this.cacheList, 'userList', this.tableData);
      this.tjList();

      this.$message.success(this.$t('general.ModSucc'));
      this.addUserDialogVisible = false;
    },
    addUserListHandlen (list) {
      let isRepeat = this.repeatVerification(list);
      if (isRepeat) {
        this.$message.error(this.$t('newApp.Customers.dnar'));
        return;
      }
      list.forEach(item => {
        // 修复回显有一个空字符的问题 2025年7月30日 16点07分
        item.opportunityName = item.opportunityName ? item.opportunityName.split(',') : [];
        item.custId = item.id;
      });
      this.tableData = [
        ...list,
        ...this.$refs.userSelectionTable.staticTableList
      ];
      this.$set(this.cacheList, 'userList', this.tableData);

      this.tjList();
      this.$message.success(this.$t('general.AddSucc'));
      this.addUserDialogVisible = false;
    },
    tjList () {
      // 统计数据
      let statistics = {
        ca: {},
        noocc: 0,
        noucc: 0,
        nolcc: 0,
        noncc: 0,
        nocfuc: 0,
        nolccx: 0,
        nonlcc: 0,
        tbps: 0
      };
      this.tableData.forEach(item => {
        const oldAccountList = [this.$t('general.yes'), this.$t('general.Ocus')];
        const filterList = [null, undefined, 'undefined'];
        if (item.isChannel !== this.$t('general.Channel')) {
          // 客户类别明细字段处理
          if (!filterList.includes(item.isOldAccount)) {
            item.isOldAccount = oldAccountList.includes(item.isOldAccount) ? this.$t('general.Ocus') : this.$t('general.Ncus');
          } else {
            if (item.columnName === '营销系统客户') {
              item.isOldAccount = '--';
            } else {
              item.isOldAccount = this.$t('general.Ncus');
            }
          }
        } else {
          item.isOldAccount = '--';
        }
      });

      // 根据clientName去重
      const tableList = this.tableData.filter((item, index, arr) => {
        return arr.findIndex(t => t.clientName === item.clientName) === index;
      });

      tableList.forEach(item => {
        // 统计数据，拟邀请客户统计
        // 统计start
        let k = item.accountMarked ? (item.accountMarked === '--' ? '空' : item.accountMarked) : '空';
        if (!statistics.ca[k]) {
          statistics.ca[k] = 0;
        }
        statistics.ca[k]++;
        if (item.isOldAccount) {
          if (item.isOldAccount === '老客户' || item.isOldAccount === '是') {
            statistics.noocc++;
          }
        }
        if (item.columnName) {
          if (item.columnName === '营销系统客户') {
            statistics.noucc++;
          }
          if (item.columnName === '列名客户') {
            statistics.nolcc++;
          }
          if (item.columnName === '非列名客户') {
            statistics.noncc++;
          }
          if (item.columnName === '营销系统渠道') {
            statistics.nocfuc++;
          }
          if (item.columnName === '列名渠道') {
            statistics.nolccx++;
          }
          if (item.columnName === '非列名渠道') {
            statistics.nonlcc++;
          }
        } else {
          statistics.noncc++;
        }
        // 统计end
      });
      for (let i of this.statisticsTable) {
        this.$refs.statisticsTable.removeRow(i);
      }
      let caContent = [];
      for (let k in statistics.ca) {
        caContent.push(`${k}${this.$t('newApp.ADList.no')}：${statistics.ca[k]}`);
      }

      const statisticsRow = {
        ...statistics,
        ca: caContent.length > 0 ? caContent.join('，') : '--'
      };
      this.statisticsTable.push(statisticsRow);
      this.$refs.statisticsTable.insertRow(statisticsRow);
      this.loadTable();
    },
    addUserDialogClose () {
      this.addUserDialogVisible = false;
      this.rowData = {};
    },
    deleteBtn (row) {
      this.$refs.userSelectionTable.staticRemoveRow(row);
      this.tjList();
      this.$message.success(this.$t('general.DeleSucc'));
    },
    editBtn (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.addUserDialogVisible = true;
    },
    validateHandler () {
      if (this.mustWrite && this.tableData.length === 0) {
        this.$message.error(this.$t('newApp.Customers.psctbi'));
        return false;
      }
      return true;
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.CustomerName'))
          ._data('clientName')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ci'))
          ._width('10%')
          ._data('isChannel')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.catt'))
          ._width('10%')
          ._data('accountMarked')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{row.accountMarked || '--'}</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.bo'))
          // ._data('businessChance')
          ._data('opportunityName')
          ._width('250')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              // console.log(this.businessList)
              return (
                <el-select
                  v-model={row['businessChanceList']}
                  placeholder={this.$t('newApp.Customers.bo')}
                  multiple
                  collapseTags
                  onChange={(val) => {
                    { /* 将多选转为字符串 */ }
                    row.businessChance = row.businessChanceList.join(',');
                    row.businessChanceCode = this.arrayQuery(val, this.businessList, 'name')?.opportunityNumber || '';
                    this.$refs.userSelectionTable.refreshColumn();
                  }}
                  onFocus={() => {
                    { /* console.log(`row.id`, row.id) */ }
                    this.businessList = [];
                    this.getBusinessNameRow(row.custId ? row.custId : row.id);
                  }}
                >
                  {this.businessList?.map(item => {
                    return <el-option label={item.name} value={item.name} />;
                  })}
                </el-select>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.newBusOpp'))
          ._width('200px')
          ._data('newBusOpp')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              return (
                <el-radio-group
                  v-model={row['newBusOpp']}>
                  <el-radio label={1}>{this.$t('general.yes')}</el-radio>
                  <el-radio label={0}>{this.$t('general.no')}</el-radio>
                </el-radio-group>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.pdty'))
          ._data('output')
          ._width('12%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.cc'))
          ._data('columnName')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.bc'))
          ._data('mustFollowC')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccd'))
          ._data('isOldAccount')
          ._width('14%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccon'))
          ._data('name')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.ADList.ContactNumber'))
          ._data('telephone')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccat'))
          ._data('entityType')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.cst'))
          ._data('channelContractType')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.noc'))
          ._data('circleName')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.wtb'))
          ._data('coconstructionOrNot')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width('140px')
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              if (row.matchResult !== 'CRM') {
                return (
                  <div>
                    {/* 这个代码会引起莫名其妙的bug，会使delete按钮不显示，我也不知道为什么，但是外层已经判断了是否为crm，所以直接就去掉了，千万要注意这个代码！！！！ */}
                    {/* {
                      () => {
                        if (row.matchResult !== 'CRM') {
                          return (
                            <el-button type="text" disabled={this.btnDisabled} onClick={() => {
                              this.editBtn(row);
                            }}>
                              {this.$t('btn.Edit')}
                            </el-button>
                          )
                        }
                      }
                    } */}
                    <el-button type="text" disabled={this.btnDisabled} onClick={() => {
                      this.editBtn(row);
                    }}>
                      {this.$t('btn.Edit')}
                    </el-button>
                    <el-button type="text" disabled={this.btnDisabled} onClick={() => {
                      this.deleteBtn(row);
                    }}>
                      {this.$t('btn.Delete')}
                    </el-button>
                  </div>
                );
              } else {
                return (
                  <div>
                    <el-button type="text" disabled={this.btnDisabled} onClick={() => {
                      this.deleteBtn(row);
                    }}>
                      {this.$t('btn.Delete')}
                    </el-button>
                  </div>
                );
              }
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.userSelectionTable.setColumn(column, {
        page: true
      });
      this.$refs.userSelectionTable.loadStaticTable(this.tableData, this.tableData.length);
    },
    arrayQuery (val, list, findKey) {
      return list.find(item => {
        return item[findKey] === val;
      });
    },
    loadStatisticsTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.ca'))
          ._data('ca')
          ._width('15%')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noocc'))
          ._data('noocc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noucc'))
          ._data('noucc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nolcc'))
          ._data('nolcc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noncc'))
          ._data('noncc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nocfuc'))
          ._data('nocfuc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nolccx'))
          ._data('nolccx')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nonlcc'))
          ._data('nonlcc')
      );

      let column = tableRow._cols();
      this.$refs.statisticsTable.setColumn(column, {
        page: false
      });
      this.tjList();
    },
    addtatisticsTable () {
      // 测试添加数据
      // this.$refs.statisticsTable.insertRow({
      //   ca: "a:1 b:2",
      //   noocc: "a:1 b:2",
      //   noucc: "a:1 b:2",
      //   nolcc: "a:1 b:2",
      //   noncc: "a:1 b:2",
      //   nocfuc: "a:1 b:2",
      //   nolccx: "a:1 b:2",
      //   nonlcc: "a:1 b:2",
      // })
    },
    templateDownload () {
      travellingTrader.getDownloadTemplate1().then(res => {
        if (res.status === '200') {
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = res.data;
          link.setAttribute('download', '');
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    async getBusinessName (row) {
      if (row.customerSaveId) {
        row.businessList = [];
        const res = await newApplicationFormApi.getBusinessName(row.customerSaveId);
        if (res.status === '200') {
          row.businessList = res.data.data;
          row.businessList.forEach(item => {
            this.$set(item, 'opportunityCode', item.opportunityNumber);
            this.$set(item, 'opportunityName', item.name);
          });
        }
      }
    },
    opportunityNameChange (e, row) {
      const currentData = e.map(item => {
        const r = row.businessList.find(i => i.opportunityName === item);
        return r ? r.opportunityCode : '';
      });
      this.$set(row, 'opportunityCode', currentData.join(','));
    },
    getBusinessNameRow (id) {
      // console.log(id)
      if (id) {
        // console.log('[info]========>in')
        this.businessList = [];
        this.businessChanceLoading = true;
        this.loadTable();
        newApplicationFormApi.getBusinessName(id).then(res => {
          // console.log(res, res.status, res.status === '200')
          this.businessChanceLoading = false;
          if (res.status === '200') {
            // res.data.data.forEach(item => {
            //   item.opportunityCode = item.opportunityNumber
            //   item.opportunityName = item.name
            // })
            // console.log(res.data.data)
            this.businessList = res.data.data;
            this.businessList.forEach(item => {
              this.$set(item, 'opportunityCode', item.opportunityNumber);
              this.$set(item, 'opportunityName', item.name);
            });
            this.loadTable();
          }
        });
      }
    }
  },
  mounted () {
    if (this.$route.query.activityCode) {
      if (this.$route.path === '/editReportApplication' || this.$store.state.newApplication.editFlag === 3) {
        this.btnDisabled = true;
      }
      if (this.$route.path === '/editIndustryReportApplication' || this.$route.path === '/editRegionReportApplication') {
        this.btnDisabled = false;
      }
      this.tableData = this.editEchoData.mactJoinCustomerList;
      this.$set(this.cacheList, 'userList', this.tableData);// this.$set(this.cacheList, 'userList', this.tableData);
    }
    this.loadTable();
    this.loadStatisticsTable();
  }
};
</script>

<style lang="scss" scoped>
// .userSelection {}</style>
